import { parseFontVariant } from './parseFontVariant';

const WEIGHT_LABELS: Record<number, string> = {
  100: 'Thin',
  200: 'Extra Light',
  300: 'Light',
  400: 'Regular',
  500: 'Medium',
  600: 'Semi Bold',
  700: 'Bold',
  800: 'Extra Bold',
  900: 'Black',
};

export function formatVariantLabel(variant: string): string {
  if (variant === 'regular') {
    return 'Regular';
  }

  if (variant === 'italic') {
    return 'Italic';
  }

  const { fontWeight, fontStyle } = parseFontVariant(variant);
  const weightLabel = WEIGHT_LABELS[fontWeight] ?? String(fontWeight);

  return fontStyle === 'italic' ? `${weightLabel} Italic` : weightLabel;
}
